import styled, { CSSProperties } from 'styled-components';
import { margin, MarginProps } from '../../../components/styles';

type Props = MarginProps & {
  bgColor?: 'primary' | 'secondary';
  nowrap?: boolean;
};

const Root = styled.div<Props>`
  background: ${({ theme, bgColor }) =>
    bgColor == 'secondary'
      ? theme.backgroundColors.green
      : theme.backgroundColors.primary};
  padding: ${({ theme }) => `${theme.spaces.xxxxl} ${theme.spaces.xxl}`};
  ${margin};

  ${({ theme }) =>
    theme.screen.sp({
      padding: `${theme.spaces.xxxl} ${theme.spaces.xxl} ${theme.spaces.xxxxl} `,
    })}
`;

const Wrapper = styled.div`
  max-width: ${({ theme }) => theme.windowSizes.m};
  margin: 0 auto;
  display: grid;
  align-items: center;
  grid-template-columns: 0.7fr 1fr;
  gap: ${({ theme }) => theme.spaces.xxxxl};

  ${({ theme }) =>
    theme.screen.sp({
      gridTemplateColumns: '1fr',
      gap: theme.spaces.xxl,
    })}
`;

const Grid = styled.div``;

const Image = styled.div``;

const Title = styled.h1`
  color: ${({ theme }) => theme.fontColors.white};
  font-size: ${({ theme }) => theme.fontSizes.s};
`;

const Copy = styled.h2<Props>`
  color: ${({ theme }) => theme.fontColors.white};
  font-size: ${({ theme }) => theme.fontSizes.xxxxl};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  line-height: ${({ theme }) => theme.lineHeights.m};
  margin-bottom: ${({ theme }) => theme.spaces.xxl};
  white-space: ${({ nowrap }) => (nowrap ? 'nowrap' : 'inherit')};

  ${({ theme }) =>
    theme.screen.sp({
      fontSize: '3.0rem',
    })}
`;

const Description = styled.p`
  color: ${({ theme }) => theme.fontColors.white};
  font-size: ${({ theme }) => theme.fontSizes.m};
  line-height: ${({ theme }) => theme.lineHeights.l};

  ${({ theme }) =>
    theme.screen.sp({
      fontSize: theme.fontSizes.s,
    })}
`;

export const Keyvisual = Object.assign(Root, {
  Wrapper,
  Grid,
  Title,
  Image,
  Copy,
  Description,
});
